<template>
  <div>
    <!--Icon-->
    <a
      class="c-black btn btn-outline-orange w-150px"
      :href="linkedInUrl"
      alt="Linkedin"
      target="_blank"
    >
      <!--Text-->
      <i class="fab fa-linkedin-in fs-25 mr-3"></i>
      LinkedIn
    </a>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    text: String,
  },

  computed: {
    data: () => ({
      //urlSite: window.location.href,
      urlSite: document.URL,
    }),
    linkedInUrl() {
      return `https://www.linkedin.com/shareArticle?mini=true&url=${this.urlSite}&title=${this.title}&summary=${this.text}&source=ConstrUp`;
    },
  },
};
</script>
